module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-t-lg"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyJobStatus),
      expression: "notifyJobStatus"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-email",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyJobStatus) ? _vm._i(_vm.notifyJobStatus, null) > -1 : (_vm.notifyJobStatus)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyJobStatus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyJobStatus = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyJobStatus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyJobStatus = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-email"
    }
  }, [_vm._v("\n        Notify me of job status updates\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyLoadDeliveries),
      expression: "notifyLoadDeliveries"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-email-delivery",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyLoadDeliveries) ? _vm._i(_vm.notifyLoadDeliveries, null) > -1 : (_vm.notifyLoadDeliveries)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyLoadDeliveries,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyLoadDeliveries = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyLoadDeliveries = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyLoadDeliveries = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-email-delivery"
    }
  }, [_vm._v("\n        Notify me of load deliveries\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyJobCompleted),
      expression: "notifyJobCompleted"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-job-completed",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyJobCompleted) ? _vm._i(_vm.notifyJobCompleted, null) > -1 : (_vm.notifyJobCompleted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyJobCompleted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyJobCompleted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyJobCompleted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyJobCompleted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-job-completed"
    }
  }, [_vm._v("\n        Notify me of invoices and payments\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyChildren),
      expression: "notifyChildren"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-children",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyChildren) ? _vm._i(_vm.notifyChildren, null) > -1 : (_vm.notifyChildren)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyChildren,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyChildren = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyChildren = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyChildren = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-children"
    }
  }, [_vm._v("\n        Apply notification settings to other users in our organisation (if I have any)\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3f5052f1"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/Notifications.vue
// module id = 973
// module chunks = 0